import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm, SubmissionError } from "redux-form";
import AutoComplete from "../../inputs/AutoComplete";
import TextInput from "../../inputs/TextInput";
import { Button } from "../../util/Clickable";
import * as normalize from "../../util/Normalizer";
import { IntlText } from "../../util/Text";
import * as validate from "../../util/Validator";

class LocationForm extends Component {
  state = {
    loading: false,
  };

  onSubmit = (values) => {
    this.setState({
      loading: true,
    });
    return this.props.onSubmit(values).then(({ value, action }) => {
      if (value.status < 300) {
        this.setState(
          {
            loading: false,
          },
          () => {
            this.props.onSuccess &&
              this.props.onSuccess(value.data, value.response);
          },
        );
      } else {
        this.setState({
          loading: false,
        });
        const errors = Object.keys(value.errors).reduce((dic, key) => {
          dic[key] = Array.isArray(value.errors[key])
            ? value.errors[key].join("\n")
            : null;
          return dic;
        }, {});
        throw new SubmissionError(errors);
      }
    });
  };

  render = () => {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        action={this.props.action}
        method="post"
      >
        <div className="uk-margin-small">
          <Field
            name="name"
            type="text"
            component={TextInput}
            labelId="forms.attr.location.name"
            validate={[validate.required]}
            required
          />
        </div>

        <div className="uk-margin-small uk-grid-small" data-uk-grid>
          <div className="uk-width-1-4@s">
            <Field
              name="post_code"
              type="text"
              component={TextInput}
              labelId="forms.attr.post_code"
              validate={[validate.num]}
              normalize={normalize.numberOnly}
            />
          </div>
          <div className="uk-width-3-4@s">
            <Field
              name="address"
              type="text"
              component={TextInput}
              labelId="forms.attr.address"
              validate={[validate.required]}
              required
            />
          </div>
        </div>

        <div className="uk-margin-small uk-grid-small" data-uk-grid>
          <div className="uk-width-1-1">
            <Field
              name="hp"
              type="url"
              component={TextInput}
              labelId="forms.attr.hp"
              validate={[validate.url]}
            />
          </div>
          <div className="uk-width-1-2@s">
            <Field
              name="tel"
              type="tel"
              component={TextInput}
              labelId="forms.attr.tel"
              validate={[validate.tel]}
              normalize={normalize.numberOnly}
            />
          </div>
          <div className="uk-width-1-2@s">
            <Field
              name="email"
              type="email"
              component={TextInput}
              labelId="forms.attr.email"
              validate={[validate.email]}
            />
          </div>
        </div>

        <div className="uk-margin-small uk-grid-small" data-uk-grid>
          <div className="uk-width-1-2@s">
            <Field
              name="open_year"
              type="number"
              component={TextInput}
              labelId="forms.attr.location.open_year"
              validate={[validate.num]}
              normalize={normalize.numberOnly}
            />
          </div>
          <div className="uk-width-1-2@s">
            <Field
              name="place"
              component={AutoComplete}
              labelId="forms.attr.place"
              options={this.props.constant.places.map((place) => {
                return {
                  label: place.name,
                  value: place.id,
                };
              })}
            />
          </div>
        </div>

        {(() => {
          if (this.props.error) {
            return (
              <div className="uk-margin-small uk-text-danger uk-text-center@s">
                <span>{this.props.error}</span>
              </div>
            );
          }
        })()}
        <div className="uk-margin uk-text-center">
          <Button
            className="uk-button uk-button-default"
            type="submit"
            disabled={this.props.invalid}
            ga={{ category: this.props.form, action: "submit" }}
            loading={this.state.loading ? 1 : 0}
          >
            <IntlText id="forms.submit" />
          </Button>
        </div>
      </form>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    constant: state.constant,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default reduxForm({
  form: "gallery-location-Form",
  enableReinitialize: true,
})(connect(mapStateToProps, mapDispatchToProps)(LocationForm));
